import React, {useEffect, useState} from "react";

import Corpo from "../components/Corpo";
import {Link} from "react-router-dom";

import {closeGlobalPopup, globalPopup} from "../services/popup";

import {findCategoryActives} from "../services/category";
import {getUserSession} from "../services/user-service";
import {findMatchStatus, startMatchSigleplayer} from "../services/match-service";
import {useWebsocket} from "../hooks/websocket";

const TYPE_SINPLEPLAYER = 'single';

export default function TabSelTema(props) {
  const [score, setScore] = useState(0);
  const [user, setUser] = useState({});
  const { stompClient } = useWebsocket();
  
  const [temas, setTemas] = useState([]);

  const routeParam = props.location.pathname
    .replace("/tab/theme/", "")
    .split("/");

  const type = routeParam[0];
  const categoryId = routeParam[1];


  let iniciaPartida = (theme) => {
    if (isOnline()) {
      window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
      window.GLOBALS.selectedTheme = theme;
      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

      if (type === TYPE_SINPLEPLAYER) {
        startMatchSigleplayer(props, theme.id, type, categoryId);
      }
      else {
        props.history.push("/tab/" + type + "/" + categoryId + "/" + theme.id);
      }

      stompClient.publish({
        destination: "/app/register-themes-on-session",
        body: JSON.stringify({
          key: "themes-on-session",
          themeId: theme.id,
          categoryId: categoryId,
        }),
      });

    }
  };

  let isOnline = () => {
    if (window.OFFLINE.isOffline) {
      globalPopup(
        "Modo Offline",
        true,
        [
          {
            texto: "Fechar",
            acao: () => {
              closeGlobalPopup();
            },
          },
        ],
        "Esta opção não está disponível porque o dispositivo está sem acesso à internet"
      );
      return false;
    }
    else {
      return true;
    }
  };

  useEffect(() => {
    const abortController = new AbortController();
    findCategoryActives().then((res) => {
      findMatchStatus(categoryId).then((responseMatchStatus) => {
        if (localStorage.getItem("GLOBALS") != null) {
          window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
          window.GLOBALS.categoriasArray = res.data;
          localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
        }
  
        // buscar lista de temas da categoria selecionada
        if (res.data) {
          const result = res.data.find( item => item.id === parseInt(categoryId));
          if(result){

            var listaTemas = result.listaTemas || [];

            // ver status das partidas
            if(responseMatchStatus){
              listaTemas.map((tema) => {
                const status = responseMatchStatus.data.find( item => item.codigoTema === tema.id);
                tema.status = status ? status.situacaoPartida.toLowerCase() : "";
                return tema;
              });
            }

            setTemas(listaTemas);
          }
        }
      });
    });

    getUserSession().then((res) => {
      setUser(res.data);
      setScore(res.data.qtdPontos);
    });

    if (localStorage.getItem("GLOBALS") != null) {
      window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
      window.GLOBALS.isInMultiplayer = false;
      window.GLOBALS.isInSinglePlayer = false;
      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
    }

    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

    return function cleanup() {
      abortController.abort();
    };
  }, [categoryId]);

  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-content">
        <div className="view-jogo tab-selecao-tema pane pane-game">
          <div
            className=" scroll-content ionic-scroll  has-tabs-top"
            style={{ top: "56px" }}
            name={JSON.stringify(user)}
          >
            <div className="scroll">
              <div className="score">
                <div className="row ">
                  <div className="col score-points ng-binding">{score} Pts</div>
                </div>
              </div>
              <h2>Selecione o Tema</h2>

              {temas.map((theme, key) => {
                return (
                  <Link
                    key={key}
                    className={
                      "button button-full button-lg-slim " +
                      (theme.status ? theme.status : "")
                    }
                    to="#"
                    onClick={() =>
                      iniciaPartida(
                        theme
                      )
                    }
                  >
                    {theme.nome}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
